import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['originalContent', 'successIcon']

  click () {
    this.successIconTarget.classList.remove('hidden')
    this.successIconTarget.classList.add('flex')
    this.originalContentTarget.classList.remove('flex')
    this.originalContentTarget.classList.add('hidden')

    setTimeout(() => {
      this.successIconTarget.classList.add('hidden')
      this.successIconTarget.classList.remove('flex')
      this.originalContentTarget.classList.add('flex')
      this.originalContentTarget.classList.remove('hidden')
    }, 10000)
  }
}
